import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { Modal } from "react-bootstrap";
import http from "../../../Common/http-common";
import * as common from "../../../Common/common";
import * as Comp from "../../../Common/CommonComponents";
import BackModal from '../../../Components/BasicElements/BackModal';
import ConfirmModal from '../../../Components/BasicElements/ConfirmModal';
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

const AttachmentReminder = (props) => {
	const [cookies] = useCookies([]);
	const [userId] = useState(cookies.USER_ID);
	const [username] = useState(cookies.USERNAME);
	const [loading, setLoading] = useState(false);
	const [loadingText, setLoadingText] = useState("Loading....");
	const [editData, setEditData] = useState([]);
	const [inputError, setInputError] = useState([]);
	const [showConfirmModal, setShowConfirmModal] = useState(false);

	useEffect(() => {
		if (props.editData !== null) {
			setEditData({
				LEAVE_MST_ID: props.editData.LEAVE_MST_ID === null ? "" : props.editData.LEAVE_MST_ID,
				USER_MST_GUID: props.editData.USER_MST_GUID === null ? "" : props.editData.USER_MST_GUID,
				USERNAME: props.editData.USERNAME === null ? "" : props.editData.USERNAME,
				STATUS: props.editData.STATUS === null ? "" : props.editData.STATUS,
				LEAVE_TYPE: props.editData.LEAVE_TYPE === null ? "" : props.editData.LEAVE_TYPE,
			})
		}
	}, [props.editData]);

	function SaveAttachmentReminder() {
			let functionName = "";
			try {
				functionName = SaveAttachmentReminder.name;
				props.onLoading(true, "Sending this reminder, please wait...");
				const data = {
					LEAVE_MST_ID: editData.LEAVE_MST_ID,
					USER_MST_GUID: editData.USER_MST_GUID,
					USERNAME: editData.USERNAME,
					LEAVE_TYPE: editData.LEAVE_TYPE,
					LEAVE_SESSION: editData.LEAVE_SESSION,
					REASON: editData.REASON,
					SUBMIT_NAME: editData.SUBMIT_NAME,
					UPDATE_ID: userId,
					UPDATE_NAME: username,
					FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
				};

				http
					.post("api/leaveHistory/RemindAttachment", data, { timeout: 5000 })
					.then((response) => {
						toast.success("Reminder is successfully sent.");
						props.onReload();
          	setEditData([]);
					})
					.catch((err) => {
						toast.error("Failed to send reminder. Please try again.");
						common.c_LogWebError(props.page, functionName, err);
					})
					.finally(() => {
						props.onLoading(false, "Loading...");
					});
			} catch (err) {
				props.onLoading(false, "Loading...");
				toast.error("Failed to send reminder. Please try again.");
				common.c_LogWebError(props.page, functionName, err);
			}
	};

	//#region Event handler
	const hideModal = () => {
		setEditData([]);
		setInputError([]);
		props.onHide();
	};

	const handleConfirmBack = () => {
		hideModal();
	};

	const handleConfirm = () => {
		setShowConfirmModal(true);
	};

	const handleConfirmModal = () => {
		SaveAttachmentReminder();
		setShowConfirmModal(false); // Hide confirm modal
		hideModal();
	};

	const handleConfirmModalClose = () => {
		setShowConfirmModal(false); // Hide back modal on cancel
	};
	//#endregion

	return (
		<>
			<Modal show={props.showHide} onHide={hideModal} centered>
				<Modal.Header>
					<div style={{ backgroundColor: "#FF8C00", width: "100%" }}>
						<Modal.Title style={{ textAlign: "left", marginLeft: "5px" }}>Warning</Modal.Title>
					</div>
				</Modal.Header>
				<Modal.Body>
					<div>Medical certificate not found.</div>
				</Modal.Body>
				<Modal.Footer>
					<div className="onright-container">
						<Comp.Button
							id="btnCancel"
							type="cancel"
							onClick={handleConfirmBack}
						>
							<FontAwesomeIcon icon={faXmark} />&nbsp; Cancel
						</Comp.Button>
												
						<Comp.Button id="btnSave" onClick={handleConfirm} style={{ width: "140px" }}>
							<FontAwesomeIcon icon={faCheck} />&nbsp; Send Reminder
						</Comp.Button>
					</div>
				</Modal.Footer>
			</Modal>

			{/* Confirmation Modal */}
			<ConfirmModal
				show={showConfirmModal}
				onHide={handleConfirmModalClose}
				onConfirm={handleConfirmModal}
				prop="Confirm to remind"
			>
				Are you sure you want to send this reminder?
			</ConfirmModal>

			{loading && <Comp.Loading>{loadingText}</Comp.Loading>}
			<Comp.AlertPopup />
		</>
	);
};

export default AttachmentReminder;